<template>
  <div>
    <v-form ref="form">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <div class="text-xs-left font-weight-bold">Confidential Communication</div>
            <div class="text-xs-left">
              The information contained in this transmittal may include privileged or confidential material intended solely for the
              individual to whom it is addressed. The material may also include information of a proprietary nature that is exempt from
              disclosure under applicable State and Federal laws. Such disclosure is expressly prohibited without the prior, written
              authorization of Catholic Home Care. If the recipient of this transmittal is not the intended person(s), you are notified
              that any unauthorized dissemination, distribution, or duplication of this material is strictly prohibited. If you have
              received this communication in error, please notify the sender immediately, and return the original communication to the
              address above by US Postal Service. The recipient of patient information is prohibited from disclosing the information to any
              other party and is required to destroy the information after the stated need has been fulfilled.”
            </div>
          </v-flex>
        </v-layout>
        <v-subheader class="black--text" style="padding:0px">Patient Information</v-subheader>
        <v-layout row wrap>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.ptFirstName"
              label="First Name"
              name="Patient First Name"
              v-validate="'required'"
              :error-messages="errors.collect('Patient First Name')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md2>
            <v-text-field v-model="ref.ptMiddleInitial" label="Middle Initial"></v-text-field>
          </v-flex>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.ptLastName"
              label="Last Name"
              name="Patient Last Name"
              v-validate="'required'"
              :error-messages="errors.collect('Patient Last Name')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.ptAddress"
              label="Address"
              name="Patient Address"
              v-validate="'required'"
              :error-messages="errors.collect('Patient Address')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.ptCity"
              label="City"
              name="Patient City"
              v-validate="'required'"
              :error-messages="errors.collect('Patient City')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md2>
            <v-text-field
              v-model="ref.ptZip"
              label="Zip Code"
              name="Patient Zip Code"
              v-validate="'required'"
              mask="#####"
              :error-messages="errors.collect('Patient Zip Code')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-text-field v-model="ref.ptPhone" label="Phone" mask="###-###-####"></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-menu
              ref="menuDOB"
              v-model="menuDOB"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  id="ptDOB"
                  slot="activator"
                  v-model="ref.ptDOB"
                  label="Date of Birth"
                  name="Date of Birth"
                  prepend-icon="event"
                  v-validate="'required'"
                  :error-messages="errors.collect('Date of Birth')"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="ref.ptDOB"
                :max="new Date().toISOString().substr(0, 10)"
                min="1900-01-01"
                @change="saveDOB"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md4>
            <v-radio-group v-model="ref.ptGender" :mandatory="false" row>
              <span style="margin-right:8px;color:rgba(0,0,0,0.54);">Gender</span>
              <v-radio label="Male" value="male"></v-radio>
              <v-radio label="Female" value="female"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-text-field
              v-model="ref.ptInsurance1"
              label="Insurance Name"
              name="Insurance Name"
              v-validate="'required'"
              :error-messages="errors.collect('Insurance Name')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field
              v-model="ref.ptPolicy1"
              label="Policy #"
              name="Policy #"
              v-validate="'required'"
              :error-messages="errors.collect('Policy #')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-text-field v-model="ref.ptInsurance2" label="Insurance Name"></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field v-model="ref.ptPolicy2" label="Policy #"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field v-model="ref.ptDiagnosis1" label="Diagnosis: 1"></v-text-field>
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap>
          <v-flex xs12>
            <v-text-field v-model="ref.ptDiagnosis2" label="Diagnosis: 2"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea box v-model="ref.ptMedicalHistory" label="Past Medical History"></v-textarea>
          </v-flex>
        </v-layout>-->
        <v-subheader
          class="black--text"
          style="padding:0px"
        >Comorbidities and Other Pertinent Diagnoses</v-subheader>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-checkbox multiple v-model="ref.ptComorbidities" label="CAD" value="CAD"></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox multiple v-model="ref.ptComorbidities" label="CHF" value="CHF"></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox multiple v-model="ref.ptComorbidities" label="Diabetes" value="Diabetes"></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox
              multiple
              v-model="ref.ptComorbidities"
              label="Neuromuscular Disorder"
              value="Neuromuscular Disorder"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox
              multiple
              v-model="ref.ptComorbidities"
              label="Peripheral Neuropathy"
              value="Peripheral Neuropathy"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox multiple v-model="ref.ptComorbidities" label="Cancer" value="Cancer"></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox multiple v-model="ref.ptComorbidities" label="COPD" value="COPD"></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox
              multiple
              v-model="ref.ptComorbidities"
              label="Hypertension"
              value="Hypertension"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox
              multiple
              v-model="ref.ptComorbidities"
              label="Osteoarthritis"
              value="Osteoarthritis"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox
              multiple
              v-model="ref.ptComorbidities"
              label="Other (specify)"
              value="Other"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-if="comorbiditiesOtherSelected"
              v-model="ref.ptComorbiditiesOther"
              label="Please Specify"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-radio-group v-model="ref.ptHospitalized" :mandatory="false" row>
              <span
                style="margin-right:8px;"
              >Has the patient been in a hospital or skilled nursing facility in the past 14 days?</span>
              <v-radio label="Yes" value="Yes"></v-radio>
              <v-radio label="No" value="No"></v-radio>
              <v-radio label="Unknown" value="Unknown"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-radio-group v-model="ref.ptMedicationUpdates" :mandatory="false" row>
              <span
                style="margin-right:8px;"
              >Have any new medications been added and/or existing medication changed in the past month?</span>
              <v-radio label="Yes" value="Yes"></v-radio>
              <v-radio label="No" value="No"></v-radio>
              <v-radio label="Unknown" value="Unknown"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- WADE  -->

        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="RN Evaluation for Home Care"
                  value="RN Evaluation for Home Care"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="Behavioral Health"
                  value="Behavioral Health"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox multiple v-model="ref.ptReferralType" label="Infusion" value="Infusion"></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="Wound Care"
                  value="Wound Care"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="Physical Therapy"
                  value="Physical Therapy"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="Occupational Therapy"
                  value="Occupational Therapy"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="Speech Language Pathology"
                  value="Speech Language Pathology"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md3>
                <v-checkbox
                  multiple
                  v-model="ref.ptReferralType"
                  label="Medical Social Worker"
                  value="Medical Social Worker"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-subheader class="black--text" style="padding:0px">Face to Face Encounter Certification</v-subheader>
        <v-layout row wrap>
          <v-flex xs12 md9>
            <div>I certify that a Medicare enrolled physician or a non-physician practitioner performed a face to face encounter on the above patient.</div>
          </v-flex>
          <v-flex xs12 md3>
            <v-menu
              v-model="menuEncounterDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="ref.drEncounterDate"
                  label="Encounter Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="ref.drEncounterDate" @input="menuEncounterDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <div>
              The clinical findings of this encounter support that the patient is homebound and in need of intermittent Skilled
              Nursing and/or therapy (Physical Therapy or Speech Language Pathology) and are documented below.
            </div>
            <v-textarea box v-model="ref.drMedicalFindings" label></v-textarea>
          </v-flex>
        </v-layout>
        <v-subheader class="black--text" style="padding:0px">Provider's Information</v-subheader>
        <v-layout row wrap>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.drFirstName"
              label="First Name"
              name="Provider First Name"
              v-validate="'required'"
              :error-messages="errors.collect('Provider First Name')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.drLastName"
              label="Last Name"
              name="Provider Last Name"
              v-validate="'required'"
              :error-messages="errors.collect('Provider Last Name')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.drAddress"
              label="Address"
              name="Provider Address"
              v-validate="'required'"
              :error-messages="errors.collect('Provider Address')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md5>
            <v-text-field
              v-model="ref.drCity"
              label="City"
              name="Provider City"
              v-validate="'required'"
              :error-messages="errors.collect('Provider City')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md2>
            <v-text-field
              v-model="ref.drZip"
              label="Zip Code"
              mask="#####"
              name="Provider Zip Code"
              v-validate="'required'"
              :error-messages="errors.collect('Provider Zip Code')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-text-field v-model="ref.drPhone" label="Phone" mask="###-###-####"></v-text-field>
          </v-flex>
          <v-flex xs12 md8>
            <v-text-field
              v-model="ref.drEmail"
              label="Email"
              name="Email"
              v-validate="'email'"
              :error-messages="errors.collect('Email')"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-text-field v-model="ref.drLicense" label="License"></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field v-model="ref.drNPI" label="NPI #"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            Please upload supporting documentation
            <FileDragDrop ref="fileDragDrop" @fileList="updateFileList" />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn @click="submitForm" color="success">Submit</v-btn>
            <v-btn @click="dialog = true;" color="error">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cancel?</v-card-title>
          <v-card-text>Are you sure? All data entered onto the form will be lost.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="cancelForm()">Yes</v-btn>
            <v-btn color="green darken-1" flat @click="dialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-snackbar v-model="snackbar.show" :multi-line="true" :top="true" :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn color="white" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
 
<script>
import axios from "axios";
import FileDragDrop from "./FileDragDrop";

//const url = "http://localhost:3001";
const url = "https://api002.chsli.org/homecare/";
//const url = "https://api-1.chsli.org:8000/homecare";

export default {
  components: {
    FileDragDrop
  },
  data: () => ({
    ref: { ptComorbidities: [] },
    refFiles: [],
    menuDOB: false,
    menuEncounterDate: false,
    //    formState: null,
    dialog: false,
    snackbar: {
      show: false,
      color: "",
      message: ""
    }
  }),
  mounted() {
    this.$refs.form.reset();
    this.ref = this.initializeRef();
  },
  watch: {
    menuDOB(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  computed: {
    comorbiditiesOtherSelected: function() {
      return this.ref.ptComorbidities.includes("Other");
    }
  },
  methods: {
    saveDOB(date) {
      this.$refs.menuDOB.save(date);
      // clear errors if needed.  vee-validate has an issue with disabled fields
      const field = this.$validator.fields.find({ name: "Date of Birth" });
      field.reset();
      this.$validator.errors.remove(field.name, field.scope);
    },
    updateFileList(obj) {
      this.refFiles = obj;
    },
    cancelForm() {
      this.dialog = false;
      this.ref = this.initializeRef();
    },
    submitForm() {
      this.$validator.validate().then(async valid => {
        if (!valid) {
          this.$el
            .querySelector(
              '[name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView();
          window.scrollBy(0, -120); // adjust scrolling higher
          return;
        }

        let formData = new FormData();

        for (let key in this.ref) {
          formData.append(key, this.ref[key]);
        }

        for (var i = 0; i < this.refFiles.length; i++) {
          formData.append("files[" + i + "]", this.refFiles[i]);
        }

        axios
          .post(url, formData)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message =
              "Your referral has been successfully submitted.  Thank you.";
            this.snackbar.show = true;

            this.ref = this.initializeRef();
            this.$refs.fileDragDrop.reset(); // reset the child component
            this.$refs.form.reset();
          })
          .catch(error => {
            this.snackbar.color = "red";
            this.snackbar.message =
              "We're sorry, we're not able to send this information at the moment, please try again later.  " +
              error;
            this.snackbar.show = true;
          });
      });
    },
    initializeRef() {
      return {
        form: "homecare",
        ptFirstName: "",
        ptMiddleInitial: "",
        ptLastName: "",
        ptAddress: "",
        ptCity: "",
        ptZip: "",
        ptPhone: "",
        ptDOB: "",
        ptGender: "",
        ptInsurance1: "",
        ptPolicy1: "",
        ptInsurance2: "",
        ptPolicy2: "",
        ptDiagnosis1: "",
        ptDiagnosis2: "",
        ptMedicalHistory: "",
        ptReferralType: [],
        drEncounterDate: "",
        drMedicalFindings: "",
        drFirstName: "",
        drLastName: "",
        drAddress: "",
        drCity: "",
        drZip: "",
        drPhone: "",
        drEmail: "",
        drLicense: "",
        drNPI: "",
        ptComorbidities: [],
        ptHospitalized: "",
        ptMedicationUpdates: "",
        ptComorbiditiesOther: ""
      };
    }
  }
};
</script>

<style>
.v-input__slot {
  margin-bottom: 0 !important;
}
</style>